<template>
  <v-data-table :headers="headers" :items="prescriptionPeriods" sort-by="position">
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Novo facilitador
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      v-model="editedItem.name"
                      label="Nome"
                      :hide-details="!errors.editedItem"
                      :error-messages="errors.editedItem"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_prescription"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="chagePositionUp(item)">
          eva-arrow-down-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_prescription"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="chagePositionDown(item)">
          eva-arrow-up-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_prescription"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_prescription"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há facilitadores de Histórico da Moléstia Atual cadastrados
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "PrescriptionPeriod",
    data() {
      return {
        errors: {},
        dialog: null,
        editedItem: {},
        editedIndex: -1,
        headers: [
          { text: "Nome", value: "name" },
          { text: "Posição", value: "position", align: "end" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
        prescriptionPeriods: [],
      };
    },
    apollo: {
      prescriptionPeriods: {
        query: require("@/graphql/prescription/periods.gql"),
        pollInterval: 20000,
      },
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Novo facilitador" : "Editar facilitador";
      },
    },
    methods: {
      chagePositionDown(item) {
        this.repositionate(item, -1);
      },
      chagePositionUp(item) {
        this.repositionate(item, 1);
      },
      repositionate(item, positionChanger) {
        item.position += positionChanger;
        if (item.position < 0) {
          item.position = 0;
        }

        this.saveItem(item);
        let facilitators = this.lodash.filter(this.prescriptionPeriods, {
          position: item.position,
        });

        facilitators.forEach((e) => {
          if (e !== item) {
            e.position = e.position - positionChanger;
            this.saveItem(e);
          }
        });
      },
      editItem(item) {
        this.editedIndex = this.prescriptionPeriods.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse facilitador?")) {
          this.apolloMutate({
            mutation: require("@/graphql/prescription/config/delete_period.gql"),
            variables: {
              periodId: item.id,
            },
          }).then(() => {
            this.refreshList().then(() => {
              this.prescriptionPeriods.forEach((e, index) => {
                e.position = index;
                this.saveItem(e);
              });
            });

            this.$store.dispatch("createNotification", {
              message: "Cadastro deletado com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        if (!this.validate()) return;

        this.saveItem(this.editedItem);

        this.close();
      },
      saveItem(item) {
        if (!this.validate()) return;

        this.apolloMutate({
          mutation: require("@/graphql/prescription/config/save_period.gql"),
          variables: {
            periodId: this.lodash.get(item, "id", ""),
            name: item.name,
            position: this.lodash.get(item, "position", this.prescriptionPeriods.length),
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });
      },
      refreshList() {
        return this.$apollo.queries.prescriptionPeriods.refetch();
      },
      validate() {
        const errorMsg = "Esse campo deve ser preenchido.";
        this.errors = {};

        let name = this.editedItem.name;
        if (this.lodash.isEmpty(name?.trim())) {
          this.errors.editedItem = errorMsg;
        }

        if (Object.keys(this.errors).length === 0) {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
